// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"5f084481","523":"7f6817a2","740":"7b45d43a","7219":"9625b5ca"}[chunkId] + ".chunk.css";
};